<template>
	<div style="height: 250px; overflow: hidden;">
		<div v-if="!emptyState" ref="charts" style="height: 100%;"></div>
		<c-empty v-else></c-empty>
	</div>
</template>

<script>
	import * as echarts from 'echarts'

	export default {
		data() {
			return {
				emptyState: false
			}
		},

		methods: {
			update(data) {
				this.emptyState = !data.length;
				if (!this.emptyState) {
					this.$nextTick(() => {
						this.echartsObj = echarts.init(this.$refs.charts);
						this.echartsObj.setOption({
							color: ['#02F4FF', '#19AEF1', '#FF414A', '#FFBA00', '#0A71F8', '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
							tooltip: {
								trigger: 'item'
							},
							series: {
								type: 'pie',
								center: ['50%', '50%'],
								radius: ['35%', '65%'],
								label: {
									formatter: '{b}\n{d}%',
									fontSize: 13
								},
								data: data
							}
						});
					});
				}
			},

			resize() {
				this.echartsObj && this.echartsObj.resize();
			}
		}
	}
</script>

